import { color } from "chart.js/helpers";
import { IconAtom } from "../atoms/iconAtom";
import { HorizontalLayout, VerticalLayout } from "./layout";

export function SuggestedCourseComp({ onClick, title, image, selected, teaserClass }) {
    if (!image) {
        image = `https://ui-avatars.com/api/?name=${title}`;
    }

    return (
        <VerticalLayout onClick={onClick} className={`course-comp standard-rounded standard-border ${selected ? "selected-course" : ""} ${teaserClass}`} style={{ cursor: "pointer",
            backgroundColor: selected ? "var(--primary-100)" : "var(--white)",
            boxShadow: selected ? "0 0 0 2px var(--primary-500)" : "none",
            transition: "0.2s ease-in-out",
          }}>
            <img className="course-img" src={image} alt={title} />
            <HorizontalLayout className="suggest-course-container"> 
                <p className="standard-text course-title" style={{   color: selected ? "var(--primary-600)" : "var(--tandard-text-color)", }}>{title}</p>
                {selected && (
                <IconAtom color={"primary-600"} icon2={"check"}/>
            )}
            </HorizontalLayout>
        </VerticalLayout>
    );
}
